<template>
  <div :class="getBtnClass" @click="callback">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    callback: Function,
    defaultBtn:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    getBtnClass (){
      return this.defaultBtn ? 'orange-white btn' : 'traveller empty vh-align'
    }
  }
}
</script>
